export default __webpack_public_path__ + "e78f195116d18df3f58ba43340837b5d.png";